/* eslint-disable @angular-eslint/component-selector */
import { Component, input } from '@angular/core';

@Component({
  selector: 'dg-app-simple-progress-bar',
  standalone: true,
  imports: [],
  templateUrl: './simple-progress-bar.component.html',
  styleUrl: './simple-progress-bar.component.scss',
})
export class SimpleProgressBarComponent {
  percentage = input.required<number>();
}
